import { AlertTriangle } from "lucide-react";

export function DisclaimerBanner({ compact = false }) {
  return (
    <div data-testid="disclaimer-banner"
      className={`bg-gold/[0.07] border-2 border-gold/25 border-l-[6px] border-l-gold rounded-2xl text-gold-soft ${compact ? "p-3" : "p-4"}`}>
      <div className="flex items-start gap-2.5">
        <AlertTriangle size={compact ? 15 : 17} className="mt-0.5 shrink-0 text-gold" />
        <p className={`leading-relaxed text-stone-700 ${compact ? "text-[11px]" : "text-xs sm:text-[13px]"}`}>
          <strong className="text-gold-soft">Avviso:</strong> le informazioni, le stime e i valori riportati sono
          <strong className="text-gold-soft"> puramente indicativi</strong> e a scopo informativo. Nessun contenuto costituisce
          consulenza finanziaria o d'investimento. Ogni decisione è a rischio esclusivo dell'utente.
        </p>
      </div>
    </div>
  );
}
